module.exports = __webpack_public_path__ + "img/vip1.37d92a0a.png";